import React from "react";
import logoSuperDucha from "../../../../assets/images/logo-super-ducha-white.png";
import { setPage } from "../../../../stores/VacuumStore/VacuumStore";
import { PAGES } from "../../../../stores/VacuumStore/VacumStore.types";
import { TextContainer, Title, Footer } from "./StartPageStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemVacuumStyles";

const StartPage: React.FC = () => {
  const handleNext = () => {
    setPage(PAGES.VACUUM_CHOICE);
  };

  return (
    <GradientContainer onClick={handleNext}>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Title>ECONOMIZA</Title>
        <Subtitle>TEMPO | DINHEIRO</Subtitle>
      </TextContainer>
      <Footer>Toque na tela para iniciar atendimento...</Footer>
    </GradientContainer>
  );
};

export default StartPage;
